import { useAPI, useAsyncHandler } from '~/hooks/common';

import { API_ENDPOINT } from '~/constants/endpoint';

import type { TypeErrorResponseData } from '~/types/common.types';
import type { TypeGetOrdersParams, TypeGetOrdersResponse } from '~/types/order.types';

const useGetOrders = () => {
  const { runAsync } = useAsyncHandler();

  const getOrders = useAPI<TypeGetOrdersParams, TypeGetOrdersResponse>({
    endpoint: API_ENDPOINT.ORDER.GET_ORDERS,
    method: 'get',
  });

  const requestOrderList = async (
    params: TypeGetOrdersParams,
    {
      onSuccess,
      onError,
    }: {
      onSuccess?: (data: TypeGetOrdersResponse) => void;
      onError?: (error: TypeErrorResponseData['error']) => void;
    }
  ) => {
    runAsync(() => getOrders({ params }), {
      onSuccess: (data) => onSuccess?.(data),
      onError: (error: TypeErrorResponseData['error']) => {
        onError?.(error);
      },
    });
  };

  return { requestOrderList };
};

export default useGetOrders;
